<template>
  <div class="txt-grey-900" v-loading="loadingList">
    <div class="flex items-center justify-between">
      <div v-if="viewingData" class="flex gap-1 items-center fs-16 fw-500 ml-5">
        {{ viewingData.name }}
        <el-popover
          v-model="viewingData.isOpenPopover"
          popper-class="p-1 shadow"
          placement="right"
          width="135"
          trigger="click"
        >
          <div>
            <div
              @click.stop="handleDeleteVitalsignHeader(viewingData, 1)"
              class="cursor-pointer p-2"
            >Xóa phiếu</div>
            <el-divider class="my-0"></el-divider>
            <div
              @click.stop="handleDeleteVitalsignHeader(viewingData, 2)"
              class="cursor-pointer p-2"
            >Xóa chỉ số</div>
          </div>
          <div
            @click="(e) => handleOpenPopover(e, viewingData)"
            slot="reference"
            class="cursor-pointer px-2 py-1"
          >
            <svg
              width="3"
              height="15"
              viewBox="0 0 3 15"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1.5 14.5385C1.0875 14.5385 0.734417 14.3916 0.44075 14.0978C0.146917 13.8041 0 13.451 0 13.0385C0 12.626 0.146917 12.2728 0.44075 11.979C0.734417 11.6853 1.0875 11.5385 1.5 11.5385C1.9125 11.5385 2.26558 11.6853 2.55925 11.979C2.85308 12.2728 3 12.626 3 13.0385C3 13.451 2.85308 13.8041 2.55925 14.0978C2.26558 14.3916 1.9125 14.5385 1.5 14.5385ZM1.5 8.76925C1.0875 8.76925 0.734417 8.62233 0.44075 8.3285C0.146917 8.03483 0 7.68175 0 7.26925C0 6.85675 0.146917 6.50367 0.44075 6.21C0.734417 5.91617 1.0875 5.76925 1.5 5.76925C1.9125 5.76925 2.26558 5.91617 2.55925 6.21C2.85308 6.50367 3 6.85675 3 7.26925C3 7.68175 2.85308 8.03483 2.55925 8.3285C2.26558 8.62233 1.9125 8.76925 1.5 8.76925ZM1.5 3C1.0875 3 0.734417 2.85317 0.44075 2.5595C0.146917 2.26567 0 1.9125 0 1.5C0 1.0875 0.146917 0.734417 0.44075 0.44075C0.734417 0.146917 1.0875 0 1.5 0C1.9125 0 2.26558 0.146917 2.55925 0.44075C2.85308 0.734417 3 1.0875 3 1.5C3 1.9125 2.85308 2.26567 2.55925 2.5595C2.26558 2.85317 1.9125 3 1.5 3Z"
                fill="#1C1B1F"
              />
            </svg>
          </div>
        </el-popover>
      </div>
      <div
        class="flex float-right justify-content-end items-center"
        :class="!viewingData ? 'w-full' : ''"
      >
        <div
          class="flex items-center text-black fs-14 mr-3 cursor-pointer fw-600"
          @click="downloadChart"
        >
          <i class="el-icon-printer text-xl leading-none" style="color: #03267a" />
          <span class="ml-1 align-middle">
            {{
            $t("multidisciplinary_board.lbl_print")
            }}
          </span>
        </div>
        <div class="text-black fs-14 mr-3 cursor-pointer fw-600" @click="showAddUpload">
          <svg
            width="18"
            height="18"
            viewBox="0 0 18 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            class="mr-2"
          >
            <path
              d="M6.039 5.13579L8.1 3.06528V11.6984C8.1 11.9372 8.19482 12.1662 8.3636 12.335C8.53239 12.5038 8.7613 12.5987 9 12.5987C9.2387 12.5987 9.46761 12.5038 9.6364 12.335C9.80518 12.1662 9.9 11.9372 9.9 11.6984V3.06528L11.961 5.13579C12.0447 5.22017 12.1442 5.28714 12.2539 5.33284C12.3636 5.37855 12.4812 5.40208 12.6 5.40208C12.7188 5.40208 12.8364 5.37855 12.9461 5.33284C13.0558 5.28714 13.1553 5.22017 13.239 5.13579C13.3234 5.0521 13.3903 4.95254 13.436 4.84284C13.4817 4.73314 13.5052 4.61547 13.5052 4.49663C13.5052 4.37779 13.4817 4.26013 13.436 4.15043C13.3903 4.04073 13.3234 3.94116 13.239 3.85747L9.639 0.256576C9.55341 0.174619 9.45248 0.110375 9.342 0.067529C9.12288 -0.0225097 8.87712 -0.0225097 8.658 0.067529C8.54752 0.110375 8.44659 0.174619 8.361 0.256576L4.761 3.85747C4.67708 3.94141 4.61052 4.04106 4.56511 4.15072C4.51969 4.26039 4.49632 4.37793 4.49632 4.49663C4.49632 4.61534 4.51969 4.73288 4.56511 4.84254C4.61052 4.95221 4.67708 5.05186 4.761 5.13579C4.84491 5.21973 4.94454 5.28631 5.05418 5.33173C5.16382 5.37716 5.28133 5.40054 5.4 5.40054C5.51867 5.40054 5.63618 5.37716 5.74582 5.33173C5.85546 5.28631 5.95509 5.21973 6.039 5.13579ZM17.1 8.99776C16.8613 8.99776 16.6324 9.0926 16.4636 9.26142C16.2948 9.43025 16.2 9.65922 16.2 9.89798V15.2993C16.2 15.5381 16.1052 15.7671 15.9364 15.9359C15.7676 16.1047 15.5387 16.1996 15.3 16.1996H2.7C2.4613 16.1996 2.23239 16.1047 2.0636 15.9359C1.89482 15.7671 1.8 15.5381 1.8 15.2993V9.89798C1.8 9.65922 1.70518 9.43025 1.5364 9.26142C1.36761 9.0926 1.13869 8.99776 0.9 8.99776C0.661305 8.99776 0.432387 9.0926 0.263604 9.26142C0.0948211 9.43025 0 9.65922 0 9.89798V15.2993C0 16.0156 0.284464 16.7025 0.790812 17.209C1.29716 17.7155 1.98392 18 2.7 18H15.3C16.0161 18 16.7028 17.7155 17.2092 17.209C17.7155 16.7025 18 16.0156 18 15.2993V9.89798C18 9.65922 17.9052 9.43025 17.7364 9.26142C17.5676 9.0926 17.3387 8.99776 17.1 8.99776Z"
              fill="#03267A"
            />
          </svg>
          Upload Phiếu
        </div>
        <div class="flex cursor-pointer items-center mr-3" @click="showAddManual">
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            class="mr-2"
          >
            <path
              d="M9.65854 0.542969C7.74826 0.542969 5.88088 1.08972 4.29254 2.11408C2.70421 3.13845 1.46625 4.59442 0.735217 6.29787C0.00418491 8.00132 -0.187086 9.87576 0.18559 11.6841C0.558267 13.4925 1.47815 15.1536 2.82892 16.4574C4.17969 17.7612 5.90068 18.649 7.77425 19.0087C9.64783 19.3684 11.5898 19.1838 13.3547 18.4782C15.1196 17.7726 16.628 16.5778 17.6893 15.0447C18.7506 13.5116 19.3171 11.7092 19.3171 9.86542C19.3171 8.64118 19.0672 7.42892 18.5819 6.29787C18.0965 5.16682 17.385 4.13912 16.4882 3.27345C15.5913 2.40778 14.5265 1.72109 13.3547 1.2526C12.1829 0.784101 10.9269 0.542969 9.65854 0.542969ZM9.65854 17.3234C8.13032 17.3234 6.63641 16.886 5.36574 16.0665C4.09507 15.247 3.10471 14.0822 2.51988 12.7195C1.93506 11.3567 1.78204 9.85714 2.08018 8.41044C2.37832 6.96374 3.11423 5.63486 4.19485 4.59184C5.27546 3.54883 6.65225 2.83853 8.15111 2.55076C9.64997 2.26299 11.2036 2.41069 12.6155 2.97516C14.0274 3.53964 15.2341 4.49554 16.0832 5.722C16.9322 6.94845 17.3854 8.39037 17.3854 9.86542C17.3854 11.8434 16.5713 13.7404 15.1222 15.139C13.6732 16.5376 11.7078 17.3234 9.65854 17.3234ZM13.522 8.93317H10.6244V6.13644C10.6244 5.88919 10.5226 5.65207 10.3415 5.47724C10.1604 5.30241 9.9147 5.20419 9.65854 5.20419C9.40238 5.20419 9.15671 5.30241 8.97558 5.47724C8.79445 5.65207 8.69269 5.88919 8.69269 6.13644V8.93317H5.79513C5.53897 8.93317 5.2933 9.03139 5.11216 9.20622C4.93103 9.38105 4.82927 9.61817 4.82927 9.86542C4.82927 10.1127 4.93103 10.3498 5.11216 10.5246C5.2933 10.6994 5.53897 10.7977 5.79513 10.7977H8.69269V13.5944C8.69269 13.8416 8.79445 14.0788 8.97558 14.2536C9.15671 14.4284 9.40238 14.5266 9.65854 14.5266C9.9147 14.5266 10.1604 14.4284 10.3415 14.2536C10.5226 14.0788 10.6244 13.8416 10.6244 13.5944V10.7977H13.522C13.7781 10.7977 14.0238 10.6994 14.2049 10.5246C14.386 10.3498 14.4878 10.1127 14.4878 9.86542C14.4878 9.61817 14.386 9.38105 14.2049 9.20622C14.0238 9.03139 13.7781 8.93317 13.522 8.93317Z"
              fill="#03267A"
            />
          </svg>
          <span class="fs-14 fw-700 txt-grey-900">Thêm Phiếu mới</span>
        </div>
        <div
          class="flex cursor-pointer items-center"
          :class="!viewingData ? 'disabled' : ''"
          @click="showUpdateSign"
        >
          <svg
            width="18"
            height="20"
            viewBox="0 0 18 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M15.75 9.8655C15.5511 9.8655 15.3603 9.94735 15.2197 10.093C15.079 10.2387 15 10.4363 15 10.6424V15.3036C15 15.5096 14.921 15.7072 14.7803 15.8529C14.6397 15.9986 14.4489 16.0805 14.25 16.0805H3.75C3.55109 16.0805 3.36032 15.9986 3.21967 15.8529C3.07902 15.7072 3 15.5096 3 15.3036V4.4274C3 4.22136 3.07902 4.02376 3.21967 3.87807C3.36032 3.73238 3.55109 3.65053 3.75 3.65053H8.25C8.44891 3.65053 8.63968 3.56868 8.78033 3.42299C8.92098 3.2773 9 3.0797 9 2.87366C9 2.66762 8.92098 2.47002 8.78033 2.32433C8.63968 2.17864 8.44891 2.09679 8.25 2.09679H3.75C3.15326 2.09679 2.58097 2.34234 2.15901 2.77941C1.73705 3.21649 1.5 3.80929 1.5 4.4274V15.3036C1.5 15.9217 1.73705 16.5145 2.15901 16.9516C2.58097 17.3887 3.15326 17.6342 3.75 17.6342H14.25C14.8467 17.6342 15.419 17.3887 15.841 16.9516C16.2629 16.5145 16.5 15.9217 16.5 15.3036V10.6424C16.5 10.4363 16.421 10.2387 16.2803 10.093C16.1397 9.94735 15.9489 9.8655 15.75 9.8655ZM4.5 10.4559V13.7499C4.5 13.9559 4.57902 14.1535 4.71967 14.2992C4.86032 14.4449 5.05109 14.5267 5.25 14.5267H8.43C8.5287 14.5273 8.62655 14.5077 8.71793 14.4691C8.80931 14.4304 8.89242 14.3734 8.9625 14.3014L14.1525 8.91772L16.2825 6.75802C16.3528 6.68579 16.4086 6.59987 16.4467 6.5052C16.4847 6.41053 16.5043 6.30899 16.5043 6.20644C16.5043 6.10388 16.4847 6.00234 16.4467 5.90767C16.4086 5.813 16.3528 5.72708 16.2825 5.65486L13.1025 2.32208C13.0328 2.24927 12.9498 2.19147 12.8584 2.15203C12.767 2.11259 12.669 2.09229 12.57 2.09229C12.471 2.09229 12.373 2.11259 12.2816 2.15203C12.1902 2.19147 12.1072 2.24927 12.0375 2.32208L9.9225 4.52063L4.7175 9.90434C4.64799 9.97693 4.59299 10.063 4.55567 10.1577C4.51835 10.2523 4.49943 10.3537 4.5 10.4559ZM12.57 3.96905L14.6925 6.16759L13.6275 7.27075L11.505 5.07221L12.57 3.96905ZM6 10.7744L10.4475 6.16759L12.57 8.36614L8.1225 12.973H6V10.7744Z"
              fill="#03267A"
            />
          </svg>

          <span class="fs-14 fw-700 txt-grey-900">
            {{
            $t("multidisciplinary_board.lbl_modify_short")
            }}
          </span>
        </div>
      </div>
    </div>

    <div v-loading="loadingDetail">
      <div v-if="!viewingData && loadingDetail" class="py-3">&nbsp;</div>
      <EmrVitalsignDetail
        v-if="viewingData"
        :viewingData="viewingData"
        @showAddSign="showAddSign"
        :isDownload="downloadActionCount"
      />
    </div>
    <div>
      <div class="row pt-3">
        <div class="col-12">
          <p
            class="fs-20 fw-500 txt-pri"
          >PHIẾU KHÁC ({{ (vitalsignList && vitalsignList.length) || 0 }})</p>
        </div>
        <div
          class="col-lg-4 col-md-6 mb-3 vh-item"
          v-for="item in vitalsignList"
          @click="openVHeader(item)"
          :key="item.id + 'item-vh'"
        >
          <div class="flex" :set="(icon = getFileAttIcon(item))">
            <div class="mr-2">
              <div
                class="item-doc-thumb-img"
                :style="`background-image: url('${icon.path}');`"
                v-if="icon && icon.is_image"
              ></div>
              <div class="item-doc-thumb" v-if="icon && !icon.is_image">
                <img width="48" height="48" :src="icon.path" alt />
              </div>
              <svg
                width="47"
                height="47"
                viewBox="0 0 30 43"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                v-if="!icon"
              >
                <path
                  d="M28.0312 5.03906H17.0625V2.51953H12.1875V5.03906H1.21875C0.545106 5.03906 0 5.60251 0 6.29883V41.7402C0 42.4365 0.545106 43 1.21875 43H28.0312C28.7049 43 29.25 42.4365 29.25 41.7402V6.29883C29.25 5.60251 28.7049 5.03906 28.0312 5.03906Z"
                  fill="url(#paint0_linear_26602_149451)"
                />
                <path
                  d="M9.75 18.9805C9.75 19.6768 10.2951 20.2402 10.9687 20.2402H23.1562C23.8299 20.2402 24.375 19.6768 24.375 18.9805C24.375 18.2842 23.8299 17.7207 23.1562 17.7207H10.9687C10.2951 17.7207 9.75 18.2842 9.75 18.9805ZM23.1562 22.7598H6.09375C5.42011 22.7598 4.875 23.3232 4.875 24.0195C4.875 24.7158 5.42011 25.2793 6.09375 25.2793H23.1562C23.8299 25.2793 24.375 24.7158 24.375 24.0195C24.375 23.3232 23.8299 22.7598 23.1562 22.7598ZM23.1562 27.7988H6.09375C5.42011 27.7988 4.875 28.3623 4.875 29.0586C4.875 29.7549 5.42011 30.3184 6.09375 30.3184H23.1562C23.8299 30.3184 24.375 29.7549 24.375 29.0586C24.375 28.3623 23.8299 27.7988 23.1562 27.7988ZM18.2812 32.8379H6.09375C5.42011 32.8379 4.875 33.4013 4.875 34.0977C4.875 34.794 5.42011 35.3574 6.09375 35.3574H18.2812C18.9549 35.3574 19.5 34.794 19.5 34.0977C19.5 33.4013 18.9549 32.8379 18.2812 32.8379ZM8.53125 10.0781H20.7187C21.3918 10.0781 21.9375 9.51409 21.9375 8.81836V7.55859C21.9375 6.16706 20.8462 5.03906 19.5 5.03906C19.5 2.25599 17.3174 0 14.625 0C11.9326 0 9.75 2.25599 9.75 5.03906C8.40377 5.03906 7.3125 6.16706 7.3125 7.55859V8.81836C7.3125 9.51409 7.85817 10.0781 8.53125 10.0781ZM14.625 3.7793C15.2981 3.7793 15.8437 4.34317 15.8437 5.03906C15.8437 5.73479 15.2981 6.29883 14.625 6.29883C13.9519 6.29883 13.4062 5.73479 13.4062 5.03906C13.4062 4.34317 13.9519 3.7793 14.625 3.7793Z"
                  fill="url(#paint1_linear_26602_149451)"
                />
                <defs>
                  <linearGradient
                    id="paint0_linear_26602_149451"
                    x1="14.625"
                    y1="43"
                    x2="14.625"
                    y2="2.51953"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stop-color="#5558FF" />
                    <stop offset="1" stop-color="#00C0FF" />
                  </linearGradient>
                  <linearGradient
                    id="paint1_linear_26602_149451"
                    x1="14.625"
                    y1="35.3574"
                    x2="14.625"
                    y2="0"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stop-color="#ADDCFF" />
                    <stop offset="0.5028" stop-color="#EAF6FF" />
                    <stop offset="1" stop-color="#EAF6FF" />
                  </linearGradient>
                </defs>
              </svg>
            </div>
            <div>
              <p class="fs-16 fw-500 txt-pri mb-0">{{ item.name }}</p>
              <p class="fs-12 fw-500 txt-gray-600 mb-0">
                <label class="mb-0 mr-1">Ngày tạo phiếu:</label>
                <span>{{ moment(item.date).format("HH:mm DD/MM/YYYY") }}</span>
              </p>
              <p class="fs-10 fw-500 txt-pri mb-0"></p>
            </div>
            <el-popover
              v-model="item.isOpenPopover"
              popper-class="p-1 shadow"
              placement="right"
              width="135"
              trigger="click"
            >
              <div>
                <div
                  @click.stop="handleDeleteVitalsignHeader(item, 1)"
                  class="cursor-pointer p-2"
                >Xóa phiếu</div>
                <el-divider class="my-0"></el-divider>
                <div
                  @click.stop="handleDeleteVitalsignHeader(item, 2)"
                  class="cursor-pointer p-2"
                >Xóa chỉ số</div>
              </div>
              <div
                @click="(e) => handleOpenPopover(e, item)"
                slot="reference"
                class="cursor-pointer px-2 py-1"
              >
                <svg
                  width="3"
                  height="15"
                  viewBox="0 0 3 15"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M1.5 14.5385C1.0875 14.5385 0.734417 14.3916 0.44075 14.0978C0.146917 13.8041 0 13.451 0 13.0385C0 12.626 0.146917 12.2728 0.44075 11.979C0.734417 11.6853 1.0875 11.5385 1.5 11.5385C1.9125 11.5385 2.26558 11.6853 2.55925 11.979C2.85308 12.2728 3 12.626 3 13.0385C3 13.451 2.85308 13.8041 2.55925 14.0978C2.26558 14.3916 1.9125 14.5385 1.5 14.5385ZM1.5 8.76925C1.0875 8.76925 0.734417 8.62233 0.44075 8.3285C0.146917 8.03483 0 7.68175 0 7.26925C0 6.85675 0.146917 6.50367 0.44075 6.21C0.734417 5.91617 1.0875 5.76925 1.5 5.76925C1.9125 5.76925 2.26558 5.91617 2.55925 6.21C2.85308 6.50367 3 6.85675 3 7.26925C3 7.68175 2.85308 8.03483 2.55925 8.3285C2.26558 8.62233 1.9125 8.76925 1.5 8.76925ZM1.5 3C1.0875 3 0.734417 2.85317 0.44075 2.5595C0.146917 2.26567 0 1.9125 0 1.5C0 1.0875 0.146917 0.734417 0.44075 0.44075C0.734417 0.146917 1.0875 0 1.5 0C1.9125 0 2.26558 0.146917 2.55925 0.44075C2.85308 0.734417 3 1.0875 3 1.5C3 1.9125 2.85308 2.26567 2.55925 2.5595C2.26558 2.85317 1.9125 3 1.5 3Z"
                    fill="#1C1B1F"
                  />
                </svg>
              </div>
            </el-popover>
          </div>
        </div>
      </div>
    </div>
    <div
      class="modal fade"
      id="modalEmrVitalsignHeader"
      tabindex="-1"
      role="dialog"
      aria-labelledby="modalEmrVitalsignHeaderLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-form modal-lg" role="document">
        <div class="modal-content" v-loading="loadingList">
          <div class="d-flex justify-content-between p-3">
            <div
              class="fs-24 fw-700 txt-grey-900 text-center w-100 uppercase"
            >Phiếu Theo dõi chức năng sống</div>
            <button
              type="button"
              class="close bg-white border-0"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true" class="fs-30 fw-500">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row border-bottom">
              <div class="col-md-12 mb-3" v-if="modalType === 'update'">
                <label class="mb-1 fs-14 fw-500 txt-grey-900 required">Chọn chỉ số:</label>
                <el-select v-model="sign" placeholder="Chọn chỉ số" class="w-100">
                  <el-option
                    v-for="(item, index) in form.signs"
                    :key="item.id"
                    :label="`Chỉ số ${index + 1}: ${appUtils.formatTime(item.created_at)} ${appUtils.formatDate(item.created_at)}`"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </div>
              <div class="col-md-6 mb-3">
                <label class="mb-1 fs-14 fw-500 txt-grey-900 required">Tên phiếu:</label>
                <el-input v-if="modalType === 'create'" class="w-100" v-model="form.name"></el-input>
                <p v-if="modalType !== 'create'" class="fs-14 mb-0">{{ form.name }}</p>
              </div>
              <div class="col-md-6 mb-3"></div>
              <div class="col-md-6 mb-3" v-if="form.type === 2 && modalType === 'create'">
                <label class="mb-1 fs-14 fw-500 txt-grey-900 required">Ngày giờ tạo phiếu:</label>
                <input type="datetime-local" class="w-100 form-control" v-model="form.date" />
              </div>

              <div class="col-md-6 mb-3" v-else>
                <label class="mb-1 fs-14 fw-500 txt-grey-900 fw-700 required">Thời gian nhập chỉ số:</label>
                <input
                  type="datetime-local"
                  v-model="formSign.record_time"
                  class="form-control fw-500 txt-grey-900"
                  :max="moment().format('HH:mm:ss DD/MM/YYYY')"
                />
              </div>
              <!-- <div
                class="row mb-3"
                v-if="
                  viewingData &&
                  viewingData.vitalsigns &&
                  modalType === 'update'
                "
              >
                <div
                  class="col-md-4"
                  v-for="sign in viewingData.vitalsigns"
                  :key="sign.id + '-sign'"
                  @click="editSign(sign)"
                >
                  <div
                    class="w-100 py-1 text-center fs-14 txt-grey-900 radius-10 cursor-pointer"
                    :class="
                      formSign && formSign.id === sign.id ? 'bg-pri-100' : ''
                    "
                  >
                    {{
                    sign.record_time &&
                    moment(sign.record_time).format("HH:mm:ss DD/MM/YYYY")
                    }}
                  </div>
                </div>
              </div>-->
              <div v-if="modalType === 'create' || modalType === 'add'" class="col-md-6 mb-3">
                <label class="mb-1 fs-14 fw-500 txt-grey-900 required">Người thực hiện:</label>
                <input
                  v-if="form.type === 2 || form.type === 1"
                  readonly
                  :value="$user.name"
                  class="form-control fw-500 txt-grey-900"
                />
                <!-- <el-select
                  v-if="form.type === 2"
                  v-model="form.performer_id"
                  filterable
                  remote
                  reserve-keyword
                  placeholder="Tìm kiếm tên bác sĩ"
                  class="w-100"
                  :remote-method="getDoctor"
                  :loading="loadingDoctor"
                >
                  <el-option
                    v-for="item in doctors"
                    :key="item.id + 'dtr'"
                    :label="item.name"
                    :value="item.user_id"
                  >
                  </el-option>
                </el-select>
                <el-select
                  v-if="form.type === 1"
                  v-model="formSign.nurse_id"
                  filterable
                  remote
                  reserve-keyword
                  placeholder="Tìm kiếm tên bác sĩ"
                  class="w-100"
                  :remote-method="getDoctor"
                  :loading="loadingDoctor"
                >
                  <el-option
                    v-for="item in doctors"
                    :key="item.id + 'dtr'"
                    :label="item.name"
                    :value="item.user_id"
                  >
                  </el-option>
                </el-select>-->
              </div>
              <div class="col-6 flex align-items-center" v-if="modalType === 'create'">
                <el-tooltip
                  v-if="form.type === 2"
                  :content="form.pdf ? 'Đổi file' : 'Chọn file'"
                  placement="left"
                >
                  <div
                    class="mb-2 fs-14 fw-500 txt-grey-900 d-flex cursor-pointer"
                    @click="uploadDocs"
                  >
                    <div>
                      <svg
                        width="18"
                        height="18"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        v-if="form.pdf"
                      >
                        <g clip-path="url(#clip0_24814_125783)">
                          <path
                            d="M6.14703 0H14.1772L20.9748 7.09195V20.8779C20.9748 22.6023 19.5771 24 17.8526 24H6.14703C4.42256 24 3.0249 22.6023 3.0249 20.8779V3.12212C3.0249 1.39769 4.42256 0 6.14703 0V0Z"
                            fill="#0263D1"
                          />
                          <path
                            opacity="0.302"
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M14.1675 0V7.0337H20.9747L14.1675 0Z"
                            fill="white"
                          />
                          <path
                            d="M6.95996 16.6667V12.7879H9.60769V13.5492H7.89746V14.3447H9.43913V15.1079H7.89746V16.6667H6.95996Z"
                            fill="white"
                          />
                          <path d="M11.0173 12.7879V16.6667H10.0798V12.7879H11.0173Z" fill="white" />
                          <path
                            d="M11.6058 16.6667V12.7879H12.5433V15.9053H14.1569V16.6667H11.6058Z"
                            fill="white"
                          />
                          <path
                            d="M14.6423 16.6667V12.7879H17.3468V13.5492H15.5798V14.3447H17.2085V15.1079H15.5798V15.9053H17.3468V16.6667H14.6423Z"
                            fill="white"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_24814_125783">
                            <rect width="24" height="24" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>
                    </div>
                    <div class="w-100 max-line-1">{{ form.pdf ? form.pdf.name : "Chưa thêm file" }}</div>
                  </div>
                </el-tooltip>
              </div>
              <div class="col-6 pb-2" v-if="modalType === 'create'">
                <div v-if="form.type === 2">
                  <div
                    class="btn btn-sm cursor-pointer bg-pri text-white d-block"
                    @click="uploadDocs"
                  >
                    <svg
                      width="18"
                      height="20"
                      viewBox="0 0 18 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      class="mr-2"
                    >
                      <path
                        d="M6.47064 6.42508L8.1287 4.50841V12.5001C8.1287 12.7211 8.20498 12.9331 8.34077 13.0893C8.47655 13.2456 8.66071 13.3334 8.85274 13.3334C9.04477 13.3334 9.22893 13.2456 9.36472 13.0893C9.5005 12.9331 9.57679 12.7211 9.57679 12.5001V4.50841L11.2348 6.42508C11.3022 6.50318 11.3822 6.56518 11.4705 6.60749C11.5587 6.64979 11.6533 6.67158 11.7489 6.67158C11.8445 6.67158 11.9391 6.64979 12.0274 6.60749C12.1156 6.56518 12.1957 6.50318 12.263 6.42508C12.3308 6.34761 12.3847 6.25544 12.4215 6.15389C12.4582 6.05234 12.4772 5.94342 12.4772 5.83341C12.4772 5.7234 12.4582 5.61448 12.4215 5.51293C12.3847 5.41138 12.3308 5.31921 12.263 5.24174L9.36681 1.90841C9.29795 1.83254 9.21676 1.77307 9.12788 1.73341C8.9516 1.65006 8.75388 1.65006 8.5776 1.73341C8.48873 1.77307 8.40753 1.83254 8.33867 1.90841L5.4425 5.24174C5.37499 5.31944 5.32144 5.41168 5.2849 5.5132C5.24837 5.61472 5.22956 5.72353 5.22956 5.83341C5.22956 5.94329 5.24837 6.0521 5.2849 6.15362C5.32144 6.25514 5.37499 6.34738 5.4425 6.42508C5.51 6.50278 5.59015 6.56441 5.67835 6.60646C5.76656 6.64851 5.86109 6.67015 5.95657 6.67015C6.05204 6.67015 6.14658 6.64851 6.23478 6.60646C6.32298 6.56441 6.40313 6.50278 6.47064 6.42508ZM15.3691 11.6667C15.1771 11.6667 14.9929 11.7545 14.8572 11.9108C14.7214 12.0671 14.6451 12.2791 14.6451 12.5001V15.8334C14.6451 16.0544 14.5688 16.2664 14.433 16.4227C14.2972 16.5789 14.1131 16.6667 13.921 16.6667H3.78444C3.59241 16.6667 3.40824 16.5789 3.27246 16.4227C3.13668 16.2664 3.06039 16.0544 3.06039 15.8334V12.5001C3.06039 12.2791 2.98411 12.0671 2.84832 11.9108C2.71254 11.7545 2.52838 11.6667 2.33635 11.6667C2.14432 11.6667 1.96016 11.7545 1.82437 11.9108C1.68859 12.0671 1.6123 12.2791 1.6123 12.5001V15.8334C1.6123 16.4965 1.84115 17.1323 2.24851 17.6012C2.65586 18.07 3.20835 18.3334 3.78444 18.3334H13.921C14.4971 18.3334 15.0496 18.07 15.457 17.6012C15.8643 17.1323 16.0932 16.4965 16.0932 15.8334V12.5001C16.0932 12.2791 16.0169 12.0671 15.8811 11.9108C15.7453 11.7545 15.5612 11.6667 15.3691 11.6667Z"
                        fill="white"
                      />
                    </svg>
                    {{ form.pdf_url ? "Đổi file" : "Chọn file" }}
                  </div>
                </div>
              </div>
            </div>

            <el-tooltip
              content="Bạn không phải là người nhập dữ liệu này. Bạn không thể sửa"
              placement="top"
              :disabled="!formSign.nurse_id || formSign.nurse_id == $user.id"
            >
              <div class="row pt-3" v-if="form.type === 1">
                <div class="col-md-6 mb-3 flex items-center">
                  <label class="mb-1 fs-14 fw-500 txt-grey-900 w-50 required">Mạch (lần/phút):</label>
                  <input
                    type="number"
                    :readonly="
                      formSign.nurse_id && formSign.nurse_id != $user.id
                    "
                    v-model="formSign.bpm"
                    class="w-50 form-control"
                    min="40"
                    max="180"
                  />
                </div>
                <div class="col-md-6 mb-3 flex items-center">
                  <label class="mb-1 fs-14 fw-500 txt-grey-900 w-50 required">Nhiệt độ (°C):</label>
                  <input
                    type="number"
                    step="0.01"
                    :readonly="
                      formSign.nurse_id && formSign.nurse_id != $user.id
                    "
                    v-model="formSign.temperature"
                    class="w-50 form-control"
                    min="35"
                    max="41"
                  />
                </div>
                <div class="col-md-6 mb-3 flex items-center">
                  <label class="mb-1 fs-14 fw-500 txt-grey-900 w-50">Huyết áp (mmHg):</label>
                  <div class="w-50 flex align-items-center justify-content-between">
                    <el-input
                      :disabled="
                        formSign.nurse_id && formSign.nurse_id != $user.id
                      "
                      type="number"
                      class="w-45"
                      v-model="formSign.systolic_pressure"
                    ></el-input>/
                    <el-input
                      :disabled="
                        formSign.nurse_id && formSign.nurse_id != $user.id
                      "
                      type="number"
                      class="w-45"
                      v-model="formSign.diastolic_pressure"
                    ></el-input>
                  </div>
                </div>
                <div class="col-md-6 mb-3 flex items-center">
                  <label class="mb-1 fs-14 fw-500 txt-grey-900 w-50">Cân nặng (kg):</label>
                  <input
                    type="number"
                    step="0.01"
                    :readonly="
                      formSign.nurse_id && formSign.nurse_id != $user.id
                    "
                    v-model="formSign.weight"
                    class="w-50 form-control"
                  />
                </div>
                <div class="col-md-6 mb-3 flex items-center">
                  <label class="mb-1 fs-14 fw-500 txt-grey-900 w-50">Nhịp thở (lần/phút):</label>
                  <input
                    type="number"
                    :readonly="
                      formSign.nurse_id && formSign.nurse_id != $user.id
                    "
                    v-model="formSign.breath"
                    class="w-50 form-control"
                  />
                </div>
              </div>
            </el-tooltip>
          </div>
          <div class="modal-footer">
            <el-tooltip
              content="Bạn không phải là người nhập dữ liệu này. Bạn không thể sửa"
              placement="top"
              :disabled="!formSign.nurse_id || formSign.nurse_id == $user.id"
            >
              <div>
                <button
                  type="button"
                  class="btn bg-pri text-white"
                  @click="onCreate"
                  :class="
                    modalType != 'add' &&
                    formSign.nurse_id &&
                    formSign.nurse_id !== $user.id
                      ? 'disabled'
                      : ''
                  "
                >
                  <svg
                    width="25"
                    height="25"
                    viewBox="0 0 25 25"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M5.34961 3.61963H16.5696C17.067 3.61968 17.5465 3.80508 17.9146 4.13963L20.6946 6.66663C20.9009 6.85406 21.0657 7.08254 21.1785 7.33741C21.2913 7.59228 21.3496 7.86791 21.3496 8.14663V19.6196C21.3496 20.1501 21.1389 20.6588 20.7638 21.0338C20.3888 21.4089 19.88 21.6196 19.3496 21.6196H5.34961C4.81918 21.6196 4.31047 21.4089 3.9354 21.0338C3.56032 20.6588 3.34961 20.1501 3.34961 19.6196V5.61963C3.34961 5.0892 3.56032 4.58049 3.9354 4.20542C4.31047 3.83034 4.81918 3.61963 5.34961 3.61963V3.61963ZM5.34961 5.61963V19.6196H19.3496V8.14663L16.5696 5.61963H5.34961ZM9.34961 13.6196H15.3496C15.88 13.6196 16.3888 13.8303 16.7638 14.2054C17.1389 14.5805 17.3496 15.0892 17.3496 15.6196V19.6196C17.3496 20.1501 17.1389 20.6588 16.7638 21.0338C16.3888 21.4089 15.88 21.6196 15.3496 21.6196H9.34961C8.81918 21.6196 8.31047 21.4089 7.9354 21.0338C7.56032 20.6588 7.34961 20.1501 7.34961 19.6196V15.6196C7.34961 15.0892 7.56032 14.5805 7.9354 14.2054C8.31047 13.8303 8.81918 13.6196 9.34961 13.6196ZM9.34961 15.6196V19.6196H15.3496V15.6196H9.34961ZM16.3496 6.61963C16.6148 6.61963 16.8692 6.72499 17.0567 6.91252C17.2443 7.10006 17.3496 7.35441 17.3496 7.61963V10.6196C17.3496 10.8848 17.2443 11.1392 17.0567 11.3267C16.8692 11.5143 16.6148 11.6196 16.3496 11.6196C16.0844 11.6196 15.83 11.5143 15.6425 11.3267C15.455 11.1392 15.3496 10.8848 15.3496 10.6196V7.61963C15.3496 7.35441 15.455 7.10006 15.6425 6.91252C15.83 6.72499 16.0844 6.61963 16.3496 6.61963ZM8.34961 6.61963H13.3496C13.6148 6.61963 13.8692 6.72499 14.0567 6.91252C14.2443 7.10006 14.3496 7.35441 14.3496 7.61963V10.6196C14.3496 10.8848 14.2443 11.1392 14.0567 11.3267C13.8692 11.5143 13.6148 11.6196 13.3496 11.6196H8.34961C8.08439 11.6196 7.83004 11.5143 7.6425 11.3267C7.45497 11.1392 7.34961 10.8848 7.34961 10.6196V7.61963C7.34961 7.35441 7.45497 7.10006 7.6425 6.91252C7.83004 6.72499 8.08439 6.61963 8.34961 6.61963ZM9.34961 9.61963H12.3496V8.61963H9.34961V9.61963Z"
                      fill="white"
                    />
                  </svg>
                  Lưu
                </button>
              </div>
            </el-tooltip>
          </div>
        </div>
      </div>
    </div>
    <input
      type="file"
      @change="onSelectedFile($event)"
      class="d-none"
      ref="inputFileEmrVitalsignList"
    />
    <div
      class="modal fade"
      id="ModalChiTietCNS"
      tabindex="-1"
      role="dialog"
      aria-labelledby="ModalChiTietCNSLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="d-flex justify-content-between p-3">
            <div
              class="fs-24 fw-700 txt-grey-900 text-center w-100 uppercase"
            >{{ update.show ? "Chỉnh sửa phiếu" : "Chi tiết phiếu" }}</div>
            <div class="flex flex-end items-center">
              <svg
                width="18"
                height="18"
                viewBox="0 0 25 25"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                class="mr-2 cursor-pointer"
                @click="onOpenUpdate"
                v-if="
                  viewingFileDetail &&
                  viewingFileDetail.performer_id &&
                  viewingFileDetail.performer_id == $user.id
                "
              >
                <path
                  d="M21.8749 12.4999C21.5987 12.4999 21.3337 12.6096 21.1383 12.805C20.943 13.0003 20.8333 13.2653 20.8333 13.5415V19.7915C20.8333 20.0678 20.7235 20.3327 20.5282 20.5281C20.3328 20.7234 20.0679 20.8332 19.7916 20.8332H5.20825C4.93198 20.8332 4.66703 20.7234 4.47168 20.5281C4.27633 20.3327 4.16659 20.0678 4.16659 19.7915V5.20819C4.16659 4.93192 4.27633 4.66697 4.47168 4.47162C4.66703 4.27627 4.93198 4.16652 5.20825 4.16652H11.4583C11.7345 4.16652 11.9995 4.05678 12.1948 3.86142C12.3902 3.66607 12.4999 3.40112 12.4999 3.12486C12.4999 2.84859 12.3902 2.58364 12.1948 2.38829C11.9995 2.19294 11.7345 2.08319 11.4583 2.08319H5.20825C4.37945 2.08319 3.58459 2.41243 2.99854 2.99848C2.41249 3.58453 2.08325 4.37939 2.08325 5.20819V19.7915C2.08325 20.6203 2.41249 21.4152 2.99854 22.0012C3.58459 22.5873 4.37945 22.9165 5.20825 22.9165H19.7916C20.6204 22.9165 21.4152 22.5873 22.0013 22.0012C22.5873 21.4152 22.9166 20.6203 22.9166 19.7915V13.5415C22.9166 13.2653 22.8068 13.0003 22.6115 12.805C22.4161 12.6096 22.1512 12.4999 21.8749 12.4999ZM6.24992 13.2915V17.7082C6.24992 17.9845 6.35967 18.2494 6.55502 18.4448C6.75037 18.6401 7.01532 18.7499 7.29159 18.7499H11.7083C11.8453 18.7506 11.9812 18.7244 12.1082 18.6725C12.2351 18.6207 12.3505 18.5443 12.4478 18.4478L19.6562 11.229L22.6145 8.33319C22.7121 8.23635 22.7896 8.12114 22.8425 7.99421C22.8954 7.86727 22.9226 7.73112 22.9226 7.59361C22.9226 7.45609 22.8954 7.31994 22.8425 7.193C22.7896 7.06607 22.7121 6.95086 22.6145 6.85402L18.1978 2.38527C18.101 2.28764 17.9858 2.21014 17.8589 2.15726C17.7319 2.10438 17.5958 2.07715 17.4583 2.07715C17.3207 2.07715 17.1846 2.10438 17.0577 2.15726C16.9307 2.21014 16.8155 2.28764 16.7187 2.38527L13.7812 5.33319L6.552 12.5519C6.45546 12.6493 6.37908 12.7647 6.32724 12.8916C6.2754 13.0185 6.24913 13.1544 6.24992 13.2915ZM17.4583 4.59361L20.4062 7.54152L18.927 9.02069L15.9791 6.07277L17.4583 4.59361ZM8.33325 13.7186L14.5103 7.54152L17.4583 10.4894L11.2812 16.6665H8.33325V13.7186Z"
                  fill="black"
                />
              </svg>

              <button
                type="button"
                class="close bg-white border-0"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true" class="fs-30 fw-500">&times;</span>
              </button>
            </div>
          </div>
          <div class="modal-body pt-0">
            <div class="row">
              <div class="col-4 mb-2">
                <p class="fs-14 fw-500 txt-grey-900">Tên phiếu</p>
              </div>
              <div class="col-8 mb-2">
                <p
                  class="fs-14 txt-grey-900"
                  v-if="!update.show"
                >{{ viewingFileDetail && viewingFileDetail.name }}</p>
                <input v-else type="text" v-model="update.form.name" class="form-control" />
              </div>
              <div class="col-4 mb-2">
                <p class="fs-14 fw-500 txt-grey-900">Ngày giờ tạo phiếu</p>
              </div>
              <div class="col-8 mb-2">
                <p class="fs-14 txt-grey-900" v-if="!update.show">
                  {{
                  viewingFileDetail &&
                  viewingFileDetail.date &&
                  moment(viewingFileDetail.date).format("HH:mm:ss DD/MM/YYYY")
                  }}
                </p>
                <input v-else type="datetime-local" v-model="update.form.date" class="form-control" />
              </div>
              <div class="col-4">
                <p class="fs-14 fw-500 txt-grey-900" v-if="!update.show">Người thực hiện</p>
              </div>
              <div class="col-8">
                <p class="fs-14 txt-grey-900" v-if="!update.show">
                  {{
                  viewingFileDetail &&
                  viewingFileDetail.performer &&
                  viewingFileDetail.performer.name
                  }}
                </p>
              </div>
              <div class="col-12 text-center" v-if="!update.show">
                <a
                  href="javascript:;"
                  class="txt-pri fs-14 text-decoration-underline"
                  @click="
                    openFile(viewingFileDetail && viewingFileDetail.pdf_url)
                  "
                >Xem phiếu</a>
              </div>
              <div class="col-12 flex mt-2" v-else>
                <div class="w-75">
                  <p
                    class="fs-14 fw-500 txt-grey-900"
                    v-if="!update.form.pdf"
                  >{{ appUtils.getFilename(viewingFileDetail.pdf_url) }}</p>
                  <p
                    class="fs-14 fw-500 txt-grey-900"
                    v-else
                  >{{ appUtils.getFilename(update.form.pdf.name) }}</p>
                </div>
                <div class="w-25 text-right">
                  <a
                    href="javascript:;"
                    class="txt-grey-900 fs-14 text-decoration-underline"
                    @click="openSelectFile"
                  >Thay đổi</a>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer" v-if="update.show">
            <button type="button" class="btn btn-muted" @click="onCancelUpdate">Huỷ</button>
            <button
              :disabled="loadingUpdate"
              type="button"
              class="btn bg-pri bd-pri text-white"
              @click="onSubmitUpdate"
            >
              <span
                class="spinner-border spinner-border-sm mr-1 fs-12"
                role="status"
                v-if="loadingUpdate"
              ></span>
              <svg
                v-else
                width="25"
                height="25"
                viewBox="0 0 25 25"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                class="mr-1"
              >
                <path
                  d="M5.34961 3.61963H16.5696C17.067 3.61968 17.5465 3.80508 17.9146 4.13963L20.6946 6.66663C20.9009 6.85406 21.0657 7.08254 21.1785 7.33741C21.2913 7.59228 21.3496 7.86791 21.3496 8.14663V19.6196C21.3496 20.1501 21.1389 20.6588 20.7638 21.0338C20.3888 21.4089 19.88 21.6196 19.3496 21.6196H5.34961C4.81918 21.6196 4.31047 21.4089 3.9354 21.0338C3.56032 20.6588 3.34961 20.1501 3.34961 19.6196V5.61963C3.34961 5.0892 3.56032 4.58049 3.9354 4.20542C4.31047 3.83034 4.81918 3.61963 5.34961 3.61963V3.61963ZM5.34961 5.61963V19.6196H19.3496V8.14663L16.5696 5.61963H5.34961ZM9.34961 13.6196H15.3496C15.88 13.6196 16.3888 13.8303 16.7638 14.2054C17.1389 14.5805 17.3496 15.0892 17.3496 15.6196V19.6196C17.3496 20.1501 17.1389 20.6588 16.7638 21.0338C16.3888 21.4089 15.88 21.6196 15.3496 21.6196H9.34961C8.81918 21.6196 8.31047 21.4089 7.9354 21.0338C7.56032 20.6588 7.34961 20.1501 7.34961 19.6196V15.6196C7.34961 15.0892 7.56032 14.5805 7.9354 14.2054C8.31047 13.8303 8.81918 13.6196 9.34961 13.6196ZM9.34961 15.6196V19.6196H15.3496V15.6196H9.34961ZM16.3496 6.61963C16.6148 6.61963 16.8692 6.72499 17.0567 6.91252C17.2443 7.10006 17.3496 7.35441 17.3496 7.61963V10.6196C17.3496 10.8848 17.2443 11.1392 17.0567 11.3267C16.8692 11.5143 16.6148 11.6196 16.3496 11.6196C16.0844 11.6196 15.83 11.5143 15.6425 11.3267C15.455 11.1392 15.3496 10.8848 15.3496 10.6196V7.61963C15.3496 7.35441 15.455 7.10006 15.6425 6.91252C15.83 6.72499 16.0844 6.61963 16.3496 6.61963ZM8.34961 6.61963H13.3496C13.6148 6.61963 13.8692 6.72499 14.0567 6.91252C14.2443 7.10006 14.3496 7.35441 14.3496 7.61963V10.6196C14.3496 10.8848 14.2443 11.1392 14.0567 11.3267C13.8692 11.5143 13.6148 11.6196 13.3496 11.6196H8.34961C8.08439 11.6196 7.83004 11.5143 7.6425 11.3267C7.45497 11.1392 7.34961 10.8848 7.34961 10.6196V7.61963C7.34961 7.35441 7.45497 7.10006 7.6425 6.91252C7.83004 6.72499 8.08439 6.61963 8.34961 6.61963ZM9.34961 9.61963H12.3496V8.61963H9.34961V9.61963Z"
                  fill="white"
                />
              </svg>
              Lưu
            </button>
          </div>
        </div>
      </div>
    </div>
    <input
      ref="selectFileUpdateCNS"
      class="d-none"
      name="file-upload"
      type="file"
      @change="onSelectFile"
      accept="jpeg, .png, .jpg, .gif, .svg, .doc, .docx, .pdf, .xls, .xlsx, .xlsm, .ppt, .pptx, .heic"
    />
    <ModalDeleteVitalSign ref="ModalDeleteVitalSign" @onSuccess="handleRefresh" />
  </div>
</template>

<script>
import moment from 'moment'
import _ from 'lodash'
import EmrVitalsignDetail from './EmrVitalsignDetail'
import appUtils from '../../../../utils/appUtils'
import ModalDeleteVitalSign from './ModalDeleteVitalSign.vue'

const file_icons = [
  { type: ['doc', 'docx', 'docm'], path: 'assets/images/icon/icon-doc.svg' },
  {
    type: ['pptx', 'ppsx', 'ppt', 'pptm'],
    path: 'assets/images/icon/icon-pptx.svg'
  },
  {
    type: ['xlsx', 'xlsm', 'xlsb', 'xltx'],
    path: 'assets/images/icon/icon-xls.svg'
  },
  { type: ['pdf'], path: 'assets/images/icon/icon-pdf.svg' },
  { type: ['zip', 'rar', '7z'], path: 'assets/images/icon/icon-file.svg' },
  { type: ['link'], path: 'assets/images/icon/u_link.svg' },
  { type: ['folder'], path: 'assets/images/icon/_folder.svg' }
]
export default {
  name: 'EmrVitalsignList',
  props: ['mr_id'],
  components: { EmrVitalsignDetail, ModalDeleteVitalSign },
  data () {
    return {
      exts: [
        'jpeg',
        'png',
        'jpg',
        'gif',
        'svg',
        'doc',
        'docx',
        'pdf',
        'xls',
        'xlsx',
        'xlsm',
        'ppt',
        'pptx',
        'zip',
        'rar',
        '7z',
        'link'
      ],
      img_exts: ['jpeg', 'png', 'jpg', 'gif', 'svg', 'link'],
      viewing: null,
      viewingData: null,
      moment,
      loadingList: false,
      vitalsignHeaders: [],
      loadingDoctor: false,
      doctors: [],
      doctorPaging: {},
      form: {
        id: 0,
        name:
          'Phiếu theo dõi chức năng sống ' +
          moment().format('HH:mm DD-MM-YYYY'),
        ref_id: '',
        signs: [],
        type: 1,
        pdf_url: '',
        date: moment().format('YYYY-MM-DD HH:mm'),
        pdf: null,
        performer_id: this.$user.id
      },
      loadingDetail: false,
      file_icons,
      formSign: {
        record_time: moment().format('YYYY-MM-DD HH:mm'),
        nurse_id: this.$user.id,
        bpm: '',
        temperature: '',
        systolic_pressure: null,
        diastolic_pressure: null,
        weight: null,
        breath: null
      },
      modalType: 'create',
      modalSaved: false,
      appUtils,
      viewingFileDetail: null,
      update: {
        form: {
          name: '',
          medical_record_id: null,
          performer_id: null,
          date: moment().format('YYYY-MM-DD HH:mm'),
          pdf_url: '',
          pdf: null,
          ws_id: null,
          ref_id: null,
          type: 1
        },
        show: false
      },
      loadingUpdate: false,
      modalUpdateSaved: false,
      downloadActionCount: 0,
      sign: ''
    }
  },
  mounted () {
    let self = this
    this.getVitalsignHeaders()
    this.$nextTick(function () {
      window.$('#modalEmrVitalsignHeader').on('hidden.bs.modal', function (e) {
        self.refresh()
      })
      window.$('#modalEmrVitalsignHeader').on('hide.bs.modal', function (e) {
        if (
          self.formSign?.nurse_id &&
          self.formSign.nurse_id === self.$user.id &&
          !self.modalSaved
        ) {
          if (
            !confirm(
              'Các thay đổi có thể chưa được lưu. Bạn có muốn lưu không?'
            )
          ) {
            return true
          } else self.onCreate()
        } else {
          self.modalSaved = false
        }
      })
      window.$('#ModalChiTietCNS').on('hidden.bs.modal', function (e) {
        self.getVitalsignHeaders()
      })
      window.$('#ModalChiTietCNS').on('hide.bs.modal', function (e) {
        if (self.update.show && !self.modalUpdateSaved) {
          if (
            !confirm(
              'Các thay đổi có thể chưa được lưu. Bạn có muốn lưu không?'
            )
          ) {
            return true
          } else self.onSubmitUpdate()
        } else {
          self.modalUpdateSaved = false
        }
      })
    })
    this.getDoctor()
  },
  computed: {
    vitalsignList () {
      return (
        this.vitalsignHeaders &&
        this.vitalsignHeaders
          .filter(v => !this.viewingData || this.viewingData.id !== v.id)
          ?.map(item => ({ ...item, isOpenPopover: false }))
      )
    }
  },
  watch: {
    sign (value) {
      this.formSign = this.form.signs.find(elm => elm.id === value)
    },
    '$route.query.form_id' () {
      this.showVitalsignHeader(this.$route.query.form_id)
    }
  },
  methods: {
    openVHeader (item) {
      if (item.pdf_url) {
        this.onViewFile(item)
      } else {
        this.$router.push({ query: { ...this.$route.query, form_id: item.id } })
        // this.showVitalsignHeader(item.id)
      }
    },
    isImage (ext) {
      return this.img_exts.findIndex(e => e === ext.toLowerCase()) > -1
    },
    getFileAttIcon (doc) {
      if (doc.pdf_url) {
        if (this.isImage(doc.pdf_url.split('.').pop())) {
          return { is_image: true, path: doc.pdf_url }
        } else {
          let extIc = this.file_icons.find(
            fi =>
              fi.type.findIndex(t => t === doc.pdf_url.split('.').pop()) > -1
          )
          if (extIc) {
            return { is_image: false, path: extIc.path }
          } else {
            return { is_image: false, path: this.file_icons[5].path }
          }
        }
      } else {
        return false
      }
    },
    removeASign (i) {
      this.form.signs.splice(i, 1)
    },
    refresh () {
      this.modalType = 'create'
      this.refreshForm()
      this.refreshFormsign()
    },
    showAddUpload () {
      this.modalType = 'create'
      this.form.type = 2
      this.form.signs = []
      this.refreshForm(2)
      this.showAdd(true)
    },
    showAddManual () {
      this.modalType = 'create'
      this.refreshForm(1)
      this.showAdd(true)
    },
    showAdd (show) {
      window.$('#modalEmrVitalsignHeader').modal(show ? 'show' : 'hide')
    },
    showAddSign (item) {
      this.modalType = 'add'
      this.form = {
        id: item.id,
        name: item.name,
        ws_id: item.ws_id,
        ref_id: item.ref_id,
        signs: item.vitalsigns,
        type: item.type,
        date: item.date,
        pdf_url: item.pdf_url,
        performer_id: item.performer_id
      }
      this.refreshFormsign()
      if (item.vitalsigns.length === 14) {
        this.$confirm(
          `<strong>${item.name}</strong> đã đầy. Vui lòng tạo phiếu mới để nhập thêm chỉ số.`,
          'Cảnh báo',
          {
            dangerouslyUseHTMLString: true,
            confirmButtonText: 'Tạo phiếu mới',
            cancelButtonText: 'Hủy'
          }
        ).then(() => {
          this.showAddManual()
        })
      } else this.showAdd(true)
    },
    showUpdateSign () {
      const item = this.viewingData
      this.modalType = 'update'
      this.form = {
        id: item.id,
        name: item.name,
        ws_id: item.ws_id,
        ref_id: item.ref_id,
        signs: item.vitalsigns,
        type: item.type,
        date: item.date,
        pdf_url: item.pdf_url,
        performer_id: item.performer_id
      }
      this.sign = this.form.signs[0]?.id
      if (item?.vitalsigns?.length) {
        this.editSign(item.vitalsigns[0])
      } else {
        this.refreshFormsign()
      }
      this.showAdd(true)
    },
    getDoctor (search = null) {
      if (this.$globalClinic) {
        if (this.$globalClinic?.org_id) {
          this.getOrgDoctor(search)
        } else {
          this.getClinicDoctor(search)
        }
      }
    },
    async getOrgDoctor (search = null) {
      const params = {
        limit: 50
      }
      if (search) {
        params.search = search
      }
      this.loadingDoctor = true
      await this.$rf
        .getRequest('DoctorRequest')
        .getOrgDoctor(this.$globalClinic?.org_id, params)
        .then(r => {
          this.doctors = r.data
          const hasMe = this.doctors.find(d => d.user_id === this.$user.id)
          if (!hasMe && this.$user.doctor) this.doctors.push(this.$user.doctor)
          this.doctorPaging = r.meta
        })
        .finally(() => {
          this.loadingDoctor = false
        })
    },
    async getClinicDoctor (search) {
      const params = {
        limit: 50
      }
      if (search) {
        params.search = search
      }
      this.loadingDoctor = true
      await this.$rf
        .getRequest('DoctorRequest')
        .getClinicDoctor(this.$globalClinic?.id, params)
        .then(r => {
          this.doctors = r.data.data
          this.doctors.map(d => {
            d.name = d.doctor?.name
            d.user_id = d.doctor?.user_id
          })
          const hasMe = this.doctors.find(
            d => d.doctor_id === this.$user?.doctor.id
          )
          if (!hasMe && this.$user.doctor) this.doctors.push(this.$user.doctor)
          this.doctorPaging = {
            count: r.data.count,
            current_page: r.data.current_page,
            last_page: r.data.last_page,
            per_page: r.data.per_page,
            total: r.data.total
          }
        })
        .finally(() => {
          this.loadingDoctor = false
        })
    },
    async getVitalsignHeaders (reload = false) {
      let params = {
        all: true,
        sort: 'updated_at',
        sort_by: 'desc'
      }
      this.loadingList = true
      await this.$rf
        .getRequest('DoctorRequest')
        .getVitalsignHeaders(this.mr_id, params)
        .then(r => {
          this.vitalsignHeaders = r.data
          if (reload && this.viewingData) {
            this.showVitalsignHeader(
              this.$route.query?.form_id || this.viewingData.id
            )
          } else if (r.data) {
            const vId = r.data.find(v => !v.pdf_url)?.id
            if (vId) this.showVitalsignHeader(this.$route.query?.form_id || vId)
            else this.viewingData = null
          }
        })
        .finally(() => {
          this.loadingList = false
        })
    },
    async onCreate () {
      if (!this.form.name) {
        alert('Vui lòng nhập tên phiếu')
        return
      }
      if (this.form.type === 2) {
        if (!this.form.date) {
          alert('Vui lòng chọn ngày tạo phiếu')
          return
        }
        if (!this.form.pdf) {
          alert('Vui lòng chọn file')
          return
        }
      }

      if (this.form.type === 1) {
        if (!this.formSign.nurse_id) {
          alert('Vui lòng chọn người thực hiện')
          return
        }
        if (!this.formSign.record_time) {
          alert('Vui lòng chọn ngày nhập')
          return
        }
        if (!this.formSign.bpm) {
          alert('Vui lòng nhập mạch')
          return
        }
        if (this.formSign.bpm > 200 || this.formSign.bpm < 0) {
          alert('Giá trị của mạch không lớn hơn 200 và nhỏ hơn 0')
          return
        }
        if (!this.formSign.temperature) {
          alert('Vui lòng nhập nhiệt độ')
          return
        }
        if (this.formSign.temperature > 43 || this.formSign.temperature < 35) {
          alert('Giá trị của nhiệt độ không lớn hơn 43 và nhỏ hơn 35')
          return
        }
      }
      if (this.modalType === 'add') {
        this.createVitalsign()
        return
      }
      if (this.modalType === 'update') {
        this.updateVitalsign()
        return
      }
      if (this.form.id) {
        this.onUpdate()
        return
      }
      this.form.medical_record_id = this.mr_id
      this.modalSaved = true

      const formData = this.createFormData()
      await this.$rf
        .getRequest('DoctorRequest')
        .createVitalsignHeaders(formData)
        .then(r => {
          this.$router.push({
            query: { ...this.$route.query, form_id: r?.data?.id }
          })
          this.getVitalsignHeaders()
          this.showAdd(false)
        })
        .finally(() => {
          this.loadingList = false
        })
    },
    async onUpdate () {
      if (!this.form.name) {
        alert('Vui lòng nhập tên phiếu')
        return
      }
      this.modalSaved = true
      this.form.medical_record_id = this.mr_id
      const formData = this.createFormData()
      await this.$rf
        .getRequest('DoctorRequest')
        .updateVitalsignHeaders(this.form.id, formData)
        .then(r => {
          this.getVitalsignHeaders(true)
          this.showAdd(false)
        })
        .finally(() => {
          this.loadingList = false
        })
    },
    async createVitalsign () {
      if (!this.form.id) return
      this.modalSaved = true
      let data = { ...this.formSign }
      data.emr_vitalsign_header_id = this.form.id
      await this.$rf
        .getRequest('DoctorRequest')
        .createVitalsign(data)
        .then(r => {
          this.getVitalsignHeaders(true)
          this.showAdd(false)
        })
        .finally(() => {
          this.loadingList = false
        })
    },
    async updateVitalsign () {
      if (!this.formSign.id) return
      this.modalSaved = true
      let id = this.formSign.id
      delete this.formSign.id
      await this.$rf
        .getRequest('DoctorRequest')
        .updateVitalsign(id, this.formSign)
        .then(r => {
          this.getVitalsignHeaders()
          this.showAdd(false)
        })
        .finally(() => {
          this.loadingList = false
        })
    },
    uploadDocs () {
      this.$refs.inputFileEmrVitalsignList.click()
      this.$refs.inputFileEmrVitalsignList.value = null
    },
    onSelectedFile (e) {
      const files = e.target.files
      if (files) {
        this.form.pdf = files[0]
        // for (let i = 0; i < files.length; i++) {
        //   this.form.pdf = files[i]
        // }
        this.$refs.inputFileEmrVitalsignList.value = null
      }
    },
    createFormData () {
      var formData = new FormData()

      for (var key in this.form) {
        if (key !== 'signs') {
          formData.append(key, _.isNil(this.form[key]) ? '' : this.form[key])
        }
        const signs = [this.formSign]
        if (signs?.length && this.form.type === 1) {
          signs.forEach((s, i) => {
            if (s.record_time) {
              formData.append(
                'signs[' + i + '][record_time]',
                s.record_time || null
              )
            }
            if (s.nurse_id) {
              formData.append('signs[' + i + '][nurse_id]', s.nurse_id || null)
            }
            if (s.bpm) formData.append('signs[' + i + '][bpm]', s.bpm || null)
            if (s.temperature) {
              formData.append(
                'signs[' + i + '][temperature]',
                s.temperature || null
              )
            }
            if (s.systolic_pressure) {
              formData.append(
                'signs[' + i + '][systolic_pressure]',
                s.systolic_pressure || null
              )
            }
            if (s.diastolic_pressure) {
              formData.append(
                'signs[' + i + '][diastolic_pressure]',
                s.diastolic_pressure || null
              )
            }
            if (s.weight) {
              formData.append('signs[' + i + '][weight]', s.weight || null)
            }
            if (s.breath) {
              formData.append('signs[' + i + '][breath]', s.breath || null)
            }
          })
        }
      }
      return formData
    },
    openFile (url, isChange) {
      if (this.validURL(url)) {
        window.open(url)
      }
    },
    validURL (str) {
      var pattern = new RegExp(
        '^(https?:\\/\\/)?' + // protocol
        '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
        '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
        '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
        '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
          '(\\#[-a-z\\d_]*)?$',
        'i'
      ) // fragment locator
      return !!pattern.test(str)
    },
    async showVitalsignHeader (id) {
      this.loadingDetail = true
      await this.$rf
        .getRequest('DoctorRequest')
        .showVitalsignHeader(id)
        .then(r => {
          this.viewingData = { ...r.data, isOpenPopover: false }
        })
        .finally(() => {
          this.loadingDetail = false
        })
    },
    editSign (item) {
      this.formSign = {
        id: item.id,
        record_time: item.record_time,
        nurse_id: item.nurse_id || null,
        bpm: item.bpm,
        temperature: item.temperature,
        systolic_pressure: item.systolic_pressure,
        diastolic_pressure: item.diastolic_pressure,
        weight: item.weight,
        breath: item.breath,
        emr_vitalsign_header_id: item.emr_vitalsign_header_id
      }
    },
    refreshFormsign () {
      this.formSign = {
        record_time: moment().format('YYYY-MM-DD HH:mm'),
        nurse_id: this.$user.id,
        bpm: '',
        temperature: '',
        systolic_pressure: null,
        diastolic_pressure: null,
        weight: null,
        breath: null
      }
    },
    refreshForm (type) {
      this.form = {
        id: 0,
        name:
          'Phiếu theo dõi chức năng sống ' +
          moment().format('HH:mm DD-MM-YYYY'),
        ref_id: '',
        ws_id: this.$globalClinic?.id,
        signs: [],
        type: type || 1,
        pdf_url: '',
        date: moment().format('YYYY-MM-DD HH:mm'),
        performer_id: this.$user.id,
        pdf: null
      }
    },
    onShowModaViewFile (show) {
      window.$('#ModalChiTietCNS').modal(show ? 'show' : 'hide')
    },
    onViewFile (item) {
      if (!item) return
      this.viewingFileDetail = item
      this.onShowModaViewFile(true)
    },
    onOpenUpdate () {
      let item = { ...this.viewingFileDetail }
      this.modalUpdateSaved = false
      this.update = {
        form: {
          id: item.id,
          performer_id: item.performer_id,
          medical_record_id: item.medical_record_id,
          name: item.name,
          date:
            (item.date && moment(item.date).format('YYYY-MM-DD HH:mm')) ||
            moment().format('YYYY-MM-DD HH:mm'),
          pdf_url: item.pdf_url,
          pdf: null,
          ws_id: item.ws_id,
          ref_id: item.ref_id,
          type: 2
        },
        show: true
      }
    },
    onCancelUpdate () {
      this.update = {
        id: null,
        form: {
          name: '',
          medical_record_id: null,
          performer_id: null,
          date: moment().format('YYYY-MM-DD HH:mm'),
          pdf_url: '',
          pdf: null,
          ws_id: null,
          ref_id: null,
          type: 2
        },
        show: false,
        pdf: null
      }
    },
    async onSubmitUpdate () {
      if (!this.update.form.id) return
      if (!this.update.form.name) {
        alert('Vui lòng nhập tên')
        return
      }
      if (!this.update.form.date) {
        alert('Vui lòng nhập ngày')
        return
      }
      this.modalUpdateSaved = true
      const formData = new FormData()
      const data = (({
        medical_record_id,
        performer_id,
        name,
        date,
        pdf,
        pdf_url,
        ws_id,
        ref_id,
        type
      }) => ({
        medical_record_id,
        performer_id,
        name,
        date,
        pdf,
        pdf_url,
        ws_id,
        ref_id,
        type
      }))(this.update.form)
      for (const key in data) {
        if (data[key]) formData.append(key, data[key])
      }
      this.loadingUpdate = true
      await this.$rf
        .getRequest('DoctorRequest')
        .updateVitalsignHeaders(this.update.form.id, formData)
        .then(r => {
          this.$toast.open({
            message: 'Cập nhật thành công',
            type: 'success'
          })
          this.viewingFileDetail = {
            performer: this.viewingFileDetail?.performer,
            ...r.data
          }
          this.onCancelUpdate()
        })
        .finally(() => {
          this.loadingUpdate = false
        })
    },
    openSelectFile () {
      this.$refs.selectFileUpdateCNS.click()
      this.$refs.selectFileUpdateCNS.value = null
    },
    onSelectFile (event) {
      this.update.form.pdf = event.target.files[0]
      this.$refs.selectFileUpdateCNS.value = null
    },
    downloadChart () {
      this.downloadActionCount++
    },
    handleDeleteVitalsignHeader (item, type) {
      this.$refs.ModalDeleteVitalSign.handleOpen(type, item)
      this.isOpenPopover = false
    },
    handleRefresh () {
      this.$router.push({
        query: { ...this.$route.query, form_id: this.vitalsignList[0]?.id }
      })
      this.getVitalsignHeaders()
    },
    handleOpenPopover (e, item) {
      e.stopPropagation()
      item = { ...item, isOpenPopover: true }
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep {
  .w-45 {
    width: 45%;
  }
  .modal-form {
    width: 800px;
    max-width: 100%;
  }
  .modal-content {
    max-height: 90vh;
    overflow: auto;
  }
  td,
  th {
    font-weight: 500 !important;
    color: #101828 !important;
    border-bottom: 0 !important;
  }
  .item-v:hover {
    background: #dee1eb;
  }
  .vh-item {
    cursor: pointer;
  }
  .item-doc-thumb-img {
    width: 47px;
    height: 47px;
    background-repeat: no-repeat;
    background-size: 47px 47px;
  }
  .item-doc-thumb {
    width: 47px;
    height: 47px;
    object-fit: contain;
  }
  .el-input .el-input__inner {
    border: none !important;
  }
  .disabled {
    opacity: 0.5;
    cursor: not-allowed;
    pointer-events: none;
  }
}
</style>
